type TLink = {
  name: string
  submenu?: TLink[]
  url?: string
}

type TCategory = {
  links: TLink[]
  title: string
}

type TPath = {
  name: string
  url: string
}

export const getAllRoutesFromNavbarCategories = (categories: TCategory[]): TPath[] => {
  const result: { name: string; url: string }[] = []

  const extractLinks = (links: TLink[]) =>
    links.forEach((link) => {
      if (link.name && link.url && !result.some(({ url }) => url == link.url))
        result.push({ name: link.name, url: link.url })
      if (link.submenu) extractLinks(link.submenu)
    })

  categories.forEach((category) => extractLinks(category.links))

  return result.sort((a, b) => a.name.localeCompare(b.name))
}
